import { render, staticRenderFns } from "./HizmetlerListe.vue?vue&type=template&id=53c12632&scoped=true&"
import script from "./HizmetlerListe.vue?vue&type=script&lang=js&"
export * from "./HizmetlerListe.vue?vue&type=script&lang=js&"
import style0 from "./HizmetlerListe.vue?vue&type=style&index=0&id=53c12632&lang=scss&scoped=true&"
import style1 from "./HizmetlerListe.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c12632",
  null
  
)

export default component.exports